import React from 'react'
import { FormattedMessage } from 'react-intl';
import { Container, Row, Col } from 'reactstrap';
import Sidebar from '../components/_sidebar';
import YouTube from 'react-youtube';

export default (props) => {
  const { content } = props;
  return (
    <Container>
      <Sidebar>

        <h3 className="mb-4"><FormattedMessage id="newsroom" /></h3>
        <Row className="videos-area my-3">
          <Col sm="12" md="6">
            <YouTube videoId="oEYkgUuBSE0" className="w-100" />
          </Col>
        </Row>

        <div className="my-5">
          <h4>{content.pressInquiries}</h4>
          <p>{content.pressText}: <a href="mailto:press@scichess.com">press@scichess.com</a></p>
        </div>

        <div className="my-5">
          <h4>{content.logoTitle}</h4>
          <p>{content.logoInfo}</p>
          <a href="" className="btn btn-warning mt-4">{content.downloadLogo}
          </a>
        </div>

        <div className="my-5">
          <h4>{content.inTheNews}</h4>
          <p><FormattedMessage id="stayTuned"/></p>
        </div>



      </Sidebar>
    </Container>
  )
}



// WEBPACK FOOTER //
// ./src/pages/about/newsroom/_newsroomLayout.js